import React, { useState, useEffect, useContext } from 'react';
import './Header.css';
import { Link } from 'react-router-dom';
import image from '../../Component/image/logo.png';
import { FaBars, FaTimes, FaHandHoldingHeart, FaGlobeAmericas, FaWhatsapp, FaLink, FaFacebook } from "react-icons/fa";
import { LanguageContext, getTranslation } from '../LanguageContext';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

// ترجمات خاصة بمكون الهيدر
const headerTranslations = {
  en: {
    home: "Home",
    history: "History",
    contact: "Contact",
    donate: "Donate",
    shareWhatsapp: "WhatsApp",
    shareFacebook: "Facebook",
    copyLink: "Copy Link",
    linkCopied: "Link copied successfully!",
    shareMessage: "معاً للأطفال في أمان | Ensemble pour les enfants en sécurité\nانضم إلى دائرة السند وساعد الأطفال المتخلى عنهم. تبرعك يصنع فرقاً كبيراً في حياتهم.\nRejoignez-nous pour aider les enfants abandonnés."
  },
  fr: {
    home: "Page d'accueil",
    history: "Histoire",
    contact: "Contact",
    donate: "Donner",
    shareWhatsapp: "WhatsApp",
    shareFacebook: "Facebook",
    copyLink: "Copier le lien",
    linkCopied: "Lien copié avec succès!",
    shareMessage: "معاً للأطفال في أمان | Ensemble pour les enfants en sécurité\nانضم إلى دائرة السند وساعد الأطفال المتخلى عنهم. تبرعك يصنع فرقاً كبيراً في حياتهم.\nRejoignez-nous pour aider les enfants abandonnés."
  },
  ar: {
    home: "الصفحة الرئيسية",
    history: "تاريخنا",
    contact: "اتصل بنا",
    donate: "تبرع",
    shareWhatsapp: "واتساب",
    shareFacebook: "فيسبوك",
    copyLink: "نسخ الرابط",
    linkCopied: "تم نسخ الرابط بنجاح!",
    shareMessage: "معاً للأطفال في أمان | Ensemble pour les enfants en sécurité\nانضم إلى دائرة السند وساعد الأطفال المتخلى عنهم. تبرعك يصنع فرقاً كبيراً في حياتهم.\nRejoignez-nous pour aider les enfants abandonnés."
  }
};

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const MySwal = withReactContent(Swal);
  
  // استخدام سياق اللغة
  const { language, changeLanguage } = useContext(LanguageContext);
  
  // دالة للحصول على الترجمة - استخدام الدالة المساعدة من سياق اللغة
  const translate = (key) => getTranslation(headerTranslations, language, key);
  
  // Handle scrolling effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  
  const toggleLanguageMenu = () => {
    setShowLanguageMenu(!showLanguageMenu);
  };

  const handleShare = (platform) => {
    const pageUrl = window.location.href;
    const message = translate('shareMessage');
    const fullMessage = `${message} ${pageUrl}`;

    if (platform === 'whatsapp') {
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(fullMessage)}`;
      window.open(whatsappUrl, '_blank');
    } else if (platform === 'facebook') {
      const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`;
      window.open(facebookUrl, '_blank', 'width=600,height=400');
    } else if (platform === 'copy') {
      navigator.clipboard.writeText(pageUrl).then(() => {
        MySwal.fire({
          title: translate('linkCopied'),
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });
      });
    }
  };

  // تحديد إذا كان الاتجاه من اليمين إلى اليسار
  const isRTL = language === 'ar';

  return (
    <header className={`site-header ${isScrolled ? 'scrolled' : ''} ${isRTL ? 'rtl' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo-container">
          <img src={image} alt="ANPE Logo" />
          <div className="logo-text">
            <span className="org-name">
              {isRTL ? 'الجمعية الوطنية' : 'Association Nationale'}
            </span>
            <span className="org-tagline">
              {isRTL ? 'لحماية الطفولة' : 'Pour La Protection De l\'enfance'}
            </span>
          </div>
        </Link>
        
        <nav className={`main-nav ${isMenuOpen ? 'active' : ''}`}>
          <ul>
            <li>
              <Link to="/" onClick={closeMenu}>{translate('home')}</Link>
            </li>
            <li>
              <a href="/#about" onClick={closeMenu}>{translate('history')}</a>
            </li>
            <li>
              <a href="/#contact" onClick={closeMenu}>{translate('contact')}</a>
            </li>
          </ul>
          <Link to="/donner" className="donate-button" onClick={closeMenu}>
            <FaHandHoldingHeart />
            <span>{translate('donate')}</span>
          </Link>
          
          <div className="language-selector">
            <button className="language-button" onClick={toggleLanguageMenu}>
              <FaGlobeAmericas />
              <span>{language.toUpperCase()}</span>
            </button>
            {showLanguageMenu && (
              <div className="language-menu">
                <button 
                  className={language === 'ar' ? 'active' : ''} 
                  onClick={() => changeLanguage('ar')}
                >
                  العربية
                </button>
                <button 
                  className={language === 'fr' ? 'active' : ''}
                  onClick={() => changeLanguage('fr')}
                >
                  Français
                </button>
                <button 
                  className={language === 'en' ? 'active' : ''} 
                  onClick={() => changeLanguage('en')}
                >
                  English
                </button>
              </div>
            )}
          </div>
          
          <div className="share-buttons-menu">
            <button className="share-btn share-whatsapp" onClick={() => handleShare('whatsapp')} title={translate('shareWhatsapp')}>
              <FaWhatsapp />
              <span>{translate('shareWhatsapp')}</span>
            </button>
            <button className="share-btn share-facebook" onClick={() => handleShare('facebook')} title={translate('shareFacebook')}>
              <FaFacebook />
              <span>{translate('shareFacebook')}</span>
            </button>
            <button className="share-btn share-copy" onClick={() => handleShare('copy')} title={translate('copyLink')}>
              <FaLink />
              <span>{translate('copyLink')}</span>
            </button>
          </div>
        </nav>
        
        <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </header>
  );
};

export default Header;